var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrowLong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_933_1248)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_933_1248",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 56
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V56H24V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_933_1248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 49.7182L6.69238 28.0002L16.0001 6.28223L17.0636 8.76368L8.81931 28.0002L17.0636 47.2367L16.0001 49.7182Z",
    fill: "#758494"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_933_1248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowLong);
export default __webpack_public_path__ + "static/media/back_arrow_long.c1960684b53699b17d9ff027f7f08d2d.svg";
export { ForwardRef as ReactComponent };